define(["require", "exports", "tslib", "@arcgis/core/Graphic", "@arcgis/core/geometry/Point", "@arcgis/core/geometry/Polyline", "@arcgis/core/layers/GraphicsLayer", "@arcgis/core/rest/route", "@arcgis/core/rest/support/FeatureSet", "@arcgis/core/rest/support/RouteParameters", "@arcgis/core/symbols/PictureMarkerSymbol", "@arcgis/core/symbols/SimpleLineSymbol", "@arcgis/core/widgets/Sketch/SketchViewModel", "lodash.debounce", "mobx-react", "react", "../../dist/assets/images/i_barrier.png", "../model/services/EventManager", "../store/RouteStore", "../store/StoreManager", "../utils/ColourUtil", "../utils/GeometryUtil", "../utils/SpatialReferenceFactory", "../utils/TimeUtil", "./blocks"], function (require, exports, tslib_1, Graphic_1, Point_1, Polyline_1, GraphicsLayer_1, route, FeatureSet_1, RouteParameters_1, PictureMarkerSymbol_1, SimpleLineSymbol_1, SketchViewModel_1, lodash_debounce_1, mobx_react_1, React, i_barrier_png_1, EventManager_1, RouteStore_1, StoreManager_1, ColourUtil_1, GeometryUtil_1, SpatialReferenceFactory_1, TimeUtil_1, blocks_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EntityCreateByRouteView = void 0;
    Graphic_1 = tslib_1.__importDefault(Graphic_1);
    Point_1 = tslib_1.__importDefault(Point_1);
    Polyline_1 = tslib_1.__importDefault(Polyline_1);
    GraphicsLayer_1 = tslib_1.__importDefault(GraphicsLayer_1);
    route = tslib_1.__importStar(route);
    FeatureSet_1 = tslib_1.__importDefault(FeatureSet_1);
    RouteParameters_1 = tslib_1.__importDefault(RouteParameters_1);
    PictureMarkerSymbol_1 = tslib_1.__importDefault(PictureMarkerSymbol_1);
    SimpleLineSymbol_1 = tslib_1.__importDefault(SimpleLineSymbol_1);
    SketchViewModel_1 = tslib_1.__importDefault(SketchViewModel_1);
    lodash_debounce_1 = tslib_1.__importDefault(lodash_debounce_1);
    React = tslib_1.__importStar(React);
    i_barrier_png_1 = tslib_1.__importDefault(i_barrier_png_1);
    let EntityCreateByRouteView = exports.EntityCreateByRouteView = class EntityCreateByRouteView extends React.Component {
        constructor(props) {
            super(props);
            Object.defineProperty(this, "draw", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onDrawComplete", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onMapClick", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onKeyDown", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onKeyUp", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "plottedRoute", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "stops", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "barriers", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "graphicsLayerRoute", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "graphicsLayerPoints", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "barrierSymbol", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "routeSymbol", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "shiftKeyPressed", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "useExperimentalVersion", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "useExperimentalVersionToggled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "solveRouteDebounced", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "animationFrameId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: null
            });
            Object.defineProperty(this, "routeAnimationActive", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "stopSymbolDataUrlCache", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new Map()
            });
            Object.defineProperty(this, "addStop", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    this.setState({ selectedTool: "stop" });
                    this.deactiveDrawTool();
                    this.activateDrawTool();
                }
            });
            Object.defineProperty(this, "addBarrier", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    this.setState({ selectedTool: "barrier" });
                    this.deactiveDrawTool();
                    this.activateDrawTool();
                }
            });
            Object.defineProperty(this, "undoLastStop", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    if (this.stops.length === 0) {
                        (0, EventManager_1.notify)("No route stops to undo");
                        return;
                    }
                    const removedStop = this.stops.pop();
                    if (removedStop) {
                        this.graphicsLayerPoints.remove(removedStop);
                    }
                    if (this.stops.length < 2) {
                        this.plottedRoute = null;
                        this.graphicsLayerRoute.removeAll();
                        this.setState({ enableSave: false });
                        return;
                    }
                    this.solveRouteDebounced();
                }
            });
            Object.defineProperty(this, "addPointToRoute", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (e) => {
                    if (this.state.selectedTool == "stop") {
                        const id = `${this.stops.length + 1}`;
                        e.symbol = this.createStopSymbol(id);
                        e.attributes = { id, manual: this.shiftKeyPressed };
                        this.stops.push(e);
                    }
                    else if (this.state.selectedTool == "barrier") {
                        e.symbol = this.barrierSymbol;
                        this.barriers.push(e);
                    }
                    this.solveRouteDebounced();
                    this.activateDrawTool();
                }
            });
            Object.defineProperty(this, "cancel", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    this.stopRouteAnimation();
                    this.deactiveDrawTool();
                    (0, RouteStore_1.openRoute)({ pathname: "/tasks" });
                }
            });
            Object.defineProperty(this, "reset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    this.stopRouteAnimation();
                    this.setState({
                        enableSave: false,
                        isResolvingRoute: false
                    });
                    this.plottedRoute = null;
                    this.graphicsLayerRoute.removeAll();
                    this.graphicsLayerPoints.removeAll();
                    this.stops = [];
                    this.barriers = [];
                    this.deactiveDrawTool();
                }
            });
            Object.defineProperty(this, "save", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    this.deactiveDrawTool();
                    let route = this.plottedRoute.geometry;
                    if (route.paths.length !== 1) {
                        (0, EventManager_1.notify)("Route must be a single part polyline. Paths: " + route.paths.length);
                    }
                    (0, EventManager_1.notify)("Measuring route distance");
                    let routeDistance = yield GeometryUtil_1.GeometryUtil.measureLength(this.props.configStore.geometryServiceUrl, route, "kilometers");
                    (0, RouteStore_1.openRoute)({
                        type: "replace",
                        pathname: `/tp/create/save`,
                        state: {
                            route: route.toJSON(),
                            routeDistance: this.formatDistance(routeDistance)
                        }
                    });
                })
            });
            Object.defineProperty(this, "startRouteAnimation", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    this.routeAnimationActive = true;
                    const startTime = Date.now();
                    const animate = () => {
                        if (!this.routeAnimationActive) {
                            return;
                        }
                        const elapsed = Date.now() - startTime;
                        const cycle = (elapsed % 1000) / 1000;
                        const basePhase = cycle * Math.PI * 2;
                        const phaseStep = Math.PI / 4;
                        this.stops.forEach((stop, index) => {
                            var _a, _b;
                            const localSine = Math.sin(basePhase - index * phaseStep);
                            const sizeScale = 0.9 + (localSine + 1) * 0.1;
                            const variant = localSine >= 0.35 ? "resolving" : "normal";
                            const stopId = String((_b = (_a = stop.attributes) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : "");
                            if (stopId) {
                                stop.symbol = this.createStopSymbolVariant(stopId, variant, sizeScale);
                            }
                        });
                        if (this.routeAnimationActive && this.state.isResolvingRoute) {
                            this.animationFrameId = requestAnimationFrame(animate);
                        }
                    };
                    this.animationFrameId = requestAnimationFrame(animate);
                }
            });
            Object.defineProperty(this, "stopRouteAnimation", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    this.routeAnimationActive = false;
                    if (this.animationFrameId !== null) {
                        cancelAnimationFrame(this.animationFrameId);
                        this.animationFrameId = null;
                    }
                    this.stops.forEach(stop => {
                        var _a, _b;
                        const stopId = String((_b = (_a = stop.attributes) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : "");
                        if (stopId) {
                            stop.symbol = this.createStopSymbol(stopId);
                        }
                    });
                }
            });
            this.useExperimentalVersion = false;
            this.stops = [];
            this.barriers = [];
            this.graphicsLayerRoute = new GraphicsLayer_1.default({ id: "route" });
            this.graphicsLayerPoints = new GraphicsLayer_1.default({ id: "routeStops" });
            props.mapStore.Map.map.layers.add(this.graphicsLayerRoute);
            props.mapStore.Map.map.layers.add(this.graphicsLayerPoints);
            this.routeSymbol = new SimpleLineSymbol_1.default({
                style: "solid",
                color: ColourUtil_1.ColourUtil.PrimaryActive,
                width: 4
            });
            this.barrierSymbol = new PictureMarkerSymbol_1.default({
                url: i_barrier_png_1.default,
                width: 24,
                height: 24
            });
            this.state = {
                enableSave: false,
                selectedTool: "stop",
                isResolvingRoute: false
            };
            this.solveRouteDebounced = (0, lodash_debounce_1.default)(() => this.solveRoute(), (0, TimeUtil_1.seconds)(1));
        }
        componentDidMount() {
            this.draw = new SketchViewModel_1.default({
                view: this.props.mapStore.Map,
                layer: this.graphicsLayerPoints,
                defaultCreateOptions: {
                    mode: "click",
                },
                defaultUpdateOptions: {
                    enableRotation: false,
                    enableScaling: false,
                    enableZ: false,
                    multipleSelectionEnabled: false,
                    tool: "move"
                }
            });
            this.draw.on("create", e => {
                if (e.state == "complete") {
                    this.addPointToRoute(e.graphic);
                }
            });
            this.draw.on("update", e => {
                var _a;
                const vertexMoved = e.state == "active" && ((_a = e.toolEventInfo) === null || _a === void 0 ? void 0 : _a.type) == "move-stop";
                const notify = e.state == "complete" || vertexMoved;
                if (notify && !e.aborted) {
                    this.solveRouteDebounced();
                }
            });
            this.onKeyDown = this.props.mapStore.Map.on("key-down", e => {
                var _a, _b;
                if (((_a = e.key) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == "z" && ((((_b = e.native) === null || _b === void 0 ? void 0 : _b.ctrlKey) === true))) {
                    console.log("Ctrl+Z pressed");
                    this.undoLastStop();
                    return;
                }
                if (e.key == "Shift") {
                    console.log("shift key pressed");
                    this.shiftKeyPressed = true;
                }
                if (e.key == "Control") {
                    console.log("Control key pressed");
                    this.useExperimentalVersionToggled = true;
                }
            });
            this.onKeyUp = this.props.mapStore.Map.on("key-up", e => {
                if (e.key == "Shift") {
                    console.log("shift key unpressed");
                    this.shiftKeyPressed = false;
                }
                if (e.key == "Control") {
                    console.log("Control key unpressed");
                    this.useExperimentalVersionToggled = false;
                }
            });
            this.onRightClick();
            this.addStop();
        }
        componentWillUnmount() {
            var _a, _b, _c;
            this.stopRouteAnimation();
            (_a = this === null || this === void 0 ? void 0 : this.onMapClick) === null || _a === void 0 ? void 0 : _a.remove();
            (_b = this === null || this === void 0 ? void 0 : this.onKeyDown) === null || _b === void 0 ? void 0 : _b.remove();
            (_c = this === null || this === void 0 ? void 0 : this.onKeyUp) === null || _c === void 0 ? void 0 : _c.remove();
            this.deactiveDrawTool();
            this.draw.destroy();
            this.props.mapStore.Map.map.remove(this.graphicsLayerRoute);
            this.props.mapStore.Map.map.remove(this.graphicsLayerPoints);
        }
        activateDrawTool() {
            console.info("activateDrawTool");
            this.draw.create("point");
        }
        deactiveDrawTool() {
            if (this.onDrawComplete) {
                this.onDrawComplete.remove();
            }
            this.draw.cancel();
        }
        render() {
            return (React.createElement(blocks_1.VGroup, null,
                React.createElement(blocks_1.Header, { title: "Create Travel Permit" },
                    React.createElement(blocks_1.HGroup, null,
                        React.createElement(blocks_1.HeaderButton, { label: "Accept", disabled: !this.state.enableSave, onClick: this.save }),
                        React.createElement(blocks_1.HeaderButton, { label: "Reset", disabled: false, onClick: this.reset }),
                        React.createElement(blocks_1.HeaderButton, { label: "Cancel", color: "secondary", onClick: this.cancel }))),
                React.createElement(blocks_1.VGroup, { className: "form", style: { alignItems: "flex-start" } },
                    React.createElement(blocks_1.HGroup, { style: { marginBottom: '10px' } },
                        React.createElement("div", null, "Using the map, digitise the Travel Route"),
                        React.createElement(blocks_1.Tooltip, { text: "Using the map, left click to plot a succession of points (stops) that define your desired travel route (hold SHIFT to force a point (stop) to be added to your route or use ESC to cancel adding stops). To remove the last stop, use Ctrl Z. To move a stop, left click it, then move it with the mouse. To delete a stop, right click it." })),
                    this.useExperimentalVersion &&
                        React.createElement("div", { style: { background: "#ccc", padding: "10px", marginBottom: "10px 0px 10px 0px" } },
                            React.createElement("strong", null, "BRAT vs QRT demo instructions"),
                            React.createElement("ul", null,
                                React.createElement("li", null, "By default, the application uses the BRAT (v1) Network Analyst service to resolve routes."),
                                React.createElement("li", null, "To use the QRT (v2) Network Analyst service, hold down the CONTROL key while adding stops to the map."),
                                React.createElement("li", null, "Hold down the SHIFT key while adding a stop to force that stop to be connected by a straight line segment (bypasses network routing for that segment)"))),
                    React.createElement(blocks_1.CtaButton, { color: "primary", label: "Add Route Stop", onClick: this.addStop }),
                    React.createElement(blocks_1.CtaButton, { color: "primary", label: "Add Route Barrier", onClick: this.addBarrier }))));
        }
        onRightClick() {
            this.onMapClick = this.props.mapStore.Map.on("click", e => {
                if (e.button == 2) {
                    const screenPoint = { x: e.x, y: e.y };
                    this.props.mapStore.Map.hitTest(screenPoint).then(({ results }) => {
                        const graphicHits = results === null || results === void 0 ? void 0 : results.filter(x => x.type === "graphic").map(x => x.graphic);
                        for (let g of graphicHits) {
                            const selected = g;
                            if (selected.layer.id == "routeStops") {
                                this.graphicsLayerPoints.remove(selected);
                                const stopIndex = this.stops.indexOf(selected);
                                let barrierIndex = -1;
                                if (stopIndex !== -1) {
                                    this.stops.splice(stopIndex, 1);
                                    if (this.stops.length === 1) {
                                        this.graphicsLayerRoute.removeAll();
                                    }
                                }
                                else {
                                    barrierIndex = this.barriers.indexOf(selected);
                                    if (barrierIndex !== -1) {
                                        this.barriers.splice(barrierIndex, 1);
                                    }
                                }
                                if (stopIndex !== -1 || barrierIndex !== -1) {
                                    this.solveRouteDebounced();
                                }
                            }
                        }
                    });
                }
            });
        }
        solveRoute() {
            const createSegments = (stops) => {
                var _a;
                const segments = [];
                let currentSegmentType = null;
                let currentSegmentStops = [];
                for (let i = 0; i < stops.length; i++) {
                    const stop = stops[i];
                    const isManual = (_a = stop.attributes) === null || _a === void 0 ? void 0 : _a.manual;
                    const segmentType = isManual ? 'line' : 'route';
                    if (currentSegmentType === null) {
                        currentSegmentType = segmentType;
                        currentSegmentStops.push(stop);
                    }
                    else if (segmentType === currentSegmentType) {
                        currentSegmentStops.push(stop);
                    }
                    else {
                        if (currentSegmentStops.length >= 2) {
                            segments.push({
                                type: currentSegmentType,
                                stops: [...currentSegmentStops]
                            });
                        }
                        currentSegmentType = segmentType;
                        currentSegmentStops = [stops[i - 1], stop];
                    }
                }
                if (currentSegmentStops.length >= 2) {
                    segments.push({
                        type: currentSegmentType,
                        stops: [...currentSegmentStops]
                    });
                }
                return segments;
            };
            const processRouteSegmentUsingStraightLines = (stops) => {
                return new Promise((resolve, reject) => {
                    try {
                        const path = stops.map(stop => {
                            const point = new Point_1.default(stop.geometry);
                            return [point.x, point.y];
                        });
                        const polyline = new Polyline_1.default({
                            paths: [path],
                            spatialReference: stops[0].geometry.spatialReference
                        });
                        const firstStopPoint = new Point_1.default(stops[0].geometry);
                        const lastStopPoint = new Point_1.default(stops[stops.length - 1].geometry);
                        const expectedStart = [firstStopPoint.x, firstStopPoint.y];
                        const expectedEnd = [lastStopPoint.x, lastStopPoint.y];
                        appendToRoute(polyline, expectedStart, expectedEnd);
                        resolve();
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            };
            const processRouteSegmentUsingNA = (stops) => {
                return new Promise((resolve, reject) => {
                    const stopsFeatureSet = new FeatureSet_1.default();
                    stops.forEach(stop => stopsFeatureSet.features.push(stop));
                    const barriers = new FeatureSet_1.default();
                    this.barriers.forEach(barrier => barriers.features.push(barrier));
                    let routeTaskUrl = this.props.configStore.WebConfig.entityView.Core.CreateByRoute.NetworkAnalystServiceUrl;
                    console.log("Using Network Analyst service url: ", routeTaskUrl);
                    const routeParams = new RouteParameters_1.default();
                    routeParams.returnStops = true;
                    routeParams.returnRoutes = true;
                    routeParams.returnDirections = false;
                    routeParams.directionsLengthUnits = "kilometers";
                    routeParams.impedanceAttribute = "Length";
                    routeParams.preserveFirstStop = true;
                    routeParams.preserveLastStop = true;
                    routeParams.findBestSequence = false;
                    routeParams.outSpatialReference = SpatialReferenceFactory_1.SpatialReferenceFactory.GDA_1994;
                    routeParams.stops = stopsFeatureSet;
                    routeParams.pointBarriers = barriers;
                    route.solve(routeTaskUrl, routeParams).then((res) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                        yield (0, TimeUtil_1.wait)((0, TimeUtil_1.seconds)(0.5));
                        if ("routeResults" in res) {
                            const routes = res.routeResults;
                            if (routes.length == 1) {
                                const { route } = routes[0];
                                const firstStopPoint = new Point_1.default(stops[0].geometry);
                                const lastStopPoint = new Point_1.default(stops[stops.length - 1].geometry);
                                const expectedStart = [firstStopPoint.x, firstStopPoint.y];
                                const expectedEnd = [lastStopPoint.x, lastStopPoint.y];
                                appendToRoute(route.geometry, expectedStart, expectedEnd);
                                resolve();
                            }
                            else {
                                (0, EventManager_1.notify)("No routes found");
                                resolve();
                            }
                        }
                        else {
                            (0, EventManager_1.notify)("No routes found");
                            resolve();
                        }
                    })).catch(err => {
                        console.error(err);
                        reject(err);
                    });
                });
            };
            const appendToRoute = (geometry, expectedStart, expectedEnd) => {
                var _a, _b, _c, _d, _e, _f;
                const joinTolerance = 1e-12;
                const joinToleranceSq = joinTolerance * joinTolerance;
                const distanceSq = (a, b) => {
                    const dx = a[0] - b[0];
                    const dy = a[1] - b[1];
                    return dx * dx + dy * dy;
                };
                const pointsJoin = (a, b) => distanceSq(a, b) <= joinToleranceSq;
                if (!geometry.spatialReference || geometry.spatialReference.wkid !== SpatialReferenceFactory_1.SpatialReferenceFactory.GDA_1994.wkid) {
                    console.error("Route segment geometry is in unexpected spatial reference", geometry.spatialReference);
                    geometry.spatialReference = SpatialReferenceFactory_1.SpatialReferenceFactory.GDA_1994;
                }
                const polyline = geometry;
                if (!(polyline === null || polyline === void 0 ? void 0 : polyline.paths)) {
                    throw new Error("Route has 0 paths");
                }
                polyline.paths = polyline.paths.filter(path => path && path.length > 0);
                if (polyline.paths.length === 0) {
                    throw new Error("Route has 0 paths (post filtering)");
                }
                const assertIsContiguous = (polyline) => {
                    if (polyline.paths.length > 1) {
                        for (let i = 1; i < polyline.paths.length; i++) {
                            const previousPath = polyline.paths[i - 1];
                            const currentPath = polyline.paths[i];
                            const previousEnd = previousPath[previousPath.length - 1];
                            const currentStart = currentPath[0];
                            if (!pointsJoin(previousEnd, currentStart)) {
                                console.error("Route segment is multi-part and non-contiguous", {
                                    previousPathIndex: i - 1,
                                    currentPathIndex: i,
                                    previousEnd,
                                    currentStart
                                });
                                throw new Error("Route segment is not contiguous");
                            }
                        }
                    }
                };
                assertIsContiguous(polyline);
                const mergedInput = GeometryUtil_1.GeometryUtil.mergePolylineToSinglePathPreserveAllVertices(polyline);
                const generalizedInput = GeometryUtil_1.GeometryUtil.generalizePolylinePreservePartEndpoints(mergedInput, 0.0005, false);
                const normalisedInput = ((_b = (_a = generalizedInput === null || generalizedInput === void 0 ? void 0 : generalizedInput.paths) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0 ? generalizedInput : mergedInput;
                if (((_c = normalisedInput.paths) === null || _c === void 0 ? void 0 : _c.length) !== 1) {
                    throw new Error("Processed route segment has more than 1 path");
                }
                let incomingPath = (_e = (_d = normalisedInput.paths) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.map(vertex => [...vertex]);
                if (!incomingPath || incomingPath.length === 0) {
                    throw new Error("Processed route segment has no path");
                }
                if (expectedStart && expectedStart.length >= 2) {
                    incomingPath[0] = [...expectedStart];
                }
                if (expectedEnd && expectedEnd.length >= 2) {
                    if (incomingPath.length === 1) {
                        const sameStartAndEnd = incomingPath[0][0] === expectedEnd[0] &&
                            incomingPath[0][1] === expectedEnd[1];
                        if (!sameStartAndEnd) {
                            incomingPath.push([...expectedEnd]);
                        }
                    }
                    else {
                        incomingPath[incomingPath.length - 1] = [...expectedEnd];
                    }
                }
                if (!this.plottedRoute) {
                    this.plottedRoute = new Graphic_1.default({
                        geometry: new Polyline_1.default({
                            paths: [incomingPath],
                            spatialReference: normalisedInput.spatialReference
                        }),
                        symbol: this.routeSymbol
                    });
                    return;
                }
                const existingPolyline = this.plottedRoute.geometry;
                if (!(existingPolyline === null || existingPolyline === void 0 ? void 0 : existingPolyline.paths) || existingPolyline.paths.length !== 1) {
                    console.error("Existing plotted route must be a single path", {
                        pathCount: (_f = existingPolyline === null || existingPolyline === void 0 ? void 0 : existingPolyline.paths) === null || _f === void 0 ? void 0 : _f.length
                    });
                    throw new Error("Existing plotted route is not single-path");
                }
                const existingPath = existingPolyline.paths[0];
                if (!existingPath || existingPath.length === 0) {
                    throw new Error("Existing plotted route has no path");
                }
                const existingEnd = existingPath[existingPath.length - 1];
                const incomingStart = incomingPath[0];
                const incomingEnd = incomingPath[incomingPath.length - 1];
                let orientedIncoming = incomingPath;
                if (pointsJoin(existingEnd, incomingStart)) {
                }
                else if (pointsJoin(existingEnd, incomingEnd)) {
                    console.warn("Incoming segment is reversed relative to existing route end. Re-orienting incoming segment to match existing route direction.", {
                        existingEnd,
                        incomingStart,
                        incomingEnd
                    });
                    orientedIncoming = [...incomingPath].reverse();
                }
                else {
                    console.error("Incoming segment does not connect to current route end", {
                        existingEnd,
                        incomingStart,
                        incomingEnd
                    });
                    throw new Error("Incoming segment does not connect to route end");
                }
                const mergedPath = pointsJoin(existingEnd, orientedIncoming[0])
                    ? existingPath.concat(orientedIncoming.slice(1))
                    : existingPath.concat(orientedIncoming);
                this.plottedRoute.geometry = new Polyline_1.default({
                    paths: [mergedPath],
                    spatialReference: existingPolyline.spatialReference
                });
                assertIsContiguous(this.plottedRoute.geometry);
            };
            if (this.stops.length > 1) {
                this.setState({ isResolvingRoute: true }, () => {
                    this.startRouteAnimation();
                });
                const segments = createSegments(this.stops);
                console.log("createSegments", segments);
                this.plottedRoute = null;
                let promiseChain = Promise.resolve();
                segments.forEach(segment => {
                    promiseChain = promiseChain.then(() => {
                        if (segment.type === 'line') {
                            return processRouteSegmentUsingStraightLines(segment.stops);
                        }
                        else if (segment.type === 'route') {
                            return processRouteSegmentUsingNA(segment.stops);
                        }
                    });
                });
                promiseChain.then(() => {
                    this.stopRouteAnimation();
                    this.graphicsLayerRoute.removeAll();
                    this.graphicsLayerRoute.add(this.plottedRoute);
                    this.setState({
                        enableSave: true,
                        isResolvingRoute: false
                    });
                }).catch(err => {
                    console.error(err);
                    (0, EventManager_1.notify)("Error processing route");
                    this.stopRouteAnimation();
                    this.setState({ isResolvingRoute: false });
                });
            }
        }
        formatDistance(dist) {
            return Math.round(dist * 100) / 100;
        }
        createStopSymbol(text) {
            return this.createStopSymbolVariant(text, "normal", 1);
        }
        createStopSymbolVariant(text, variant, sizeScale) {
            const dataURL = this.getStopSymbolDataUrl(text, variant);
            const baseSize = 18;
            return new PictureMarkerSymbol_1.default({
                url: dataURL,
                width: baseSize * sizeScale,
                height: baseSize * sizeScale
            });
        }
        getStopSymbolDataUrl(text, variant) {
            const key = `${variant}:${text}`;
            const cached = this.stopSymbolDataUrlCache.get(key);
            if (cached) {
                return cached;
            }
            const w = 36;
            const x = w / 2;
            const y = x;
            const fontSize = Math.round(w * 0.6);
            const canvas = document.createElement("canvas");
            canvas.width = w;
            canvas.height = w;
            const ctx = canvas.getContext("2d");
            ctx.beginPath();
            ctx.fillStyle = variant === "resolving"
                ? "rgb(255,165,0)"
                : `rgb(${ColourUtil_1.ColourUtil.PrimaryActive.r},${ColourUtil_1.ColourUtil.PrimaryActive.g},${ColourUtil_1.ColourUtil.PrimaryActive.b})`;
            ctx.arc(x, y, w / 2, 0, 2 * Math.PI, false);
            ctx.fill();
            ctx.font = `${fontSize}pt Arial`;
            ctx.fillStyle = "white";
            ctx.textAlign = "center";
            ctx.fillText(text, x, y + fontSize / 2);
            const dataURL = canvas.toDataURL();
            this.stopSymbolDataUrlCache.set(key, dataURL);
            return dataURL;
        }
    };
    exports.EntityCreateByRouteView = EntityCreateByRouteView = tslib_1.__decorate([
        (0, mobx_react_1.inject)(context => (0, StoreManager_1.injectStores)(context)),
        mobx_react_1.observer
    ], EntityCreateByRouteView);
});
